"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = require("./Util");
var types_1 = require("../types");
var RubicsRequest_1 = require("./RubicsRequest");
var constants_1 = require("../constants");
var Tracker = /** @class */ (function () {
    function Tracker() {
    }
    Tracker.push = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!opts.dontPushToGTM) {
                            Tracker.pushToDataLayer(Tracker.convertToTagManager(opts));
                        }
                        if (!Tracker.isTrackable()) return [3 /*break*/, 2];
                        return [4 /*yield*/, RubicsRequest_1.default.fetch({
                                endpoint: constants_1.STOREFRONT_ENDPOINT + "/stats/push",
                                method: "POST",
                                body: opts,
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Tracker.products = function (type, products) {
        return __awaiter(this, void 0, void 0, function () {
            var translatedProducts, i, product;
            var _a;
            return __generator(this, function (_b) {
                translatedProducts = products.map(function (p) { return ({
                    id: p.sku,
                    name: p.name,
                    price: p.price.value.toString(),
                }); });
                if (type === "impressions") {
                    for (i = 0; i < products.length; i++) {
                        product = products[i];
                        Tracker.push({
                            type: types_1.StatType.ProductView,
                            meta1: product.sku,
                            meta2: product.name,
                            meta3: product._id,
                            value: product.price.value,
                            dontPushToGTM: true,
                        });
                    }
                    Tracker.pushToDataLayer({
                        event: "ee_productImpressions",
                        ecommerce: {
                            impressions: translatedProducts,
                        },
                    });
                }
                else {
                    Tracker.pushToDataLayer({
                        event: type === "click" ? "ee_productClick" : "ee_productDetail",
                        ecommerce: (_a = {},
                            _a[type] = {
                                products: translatedProducts,
                            },
                            _a),
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    Tracker.cart = function (type, items) {
        return __awaiter(this, void 0, void 0, function () {
            var i, item;
            var _a;
            return __generator(this, function (_b) {
                if (type === "add") {
                    for (i = 0; i < items.length; i++) {
                        item = items[i];
                        Tracker.push({
                            type: types_1.StatType.CartAdd,
                            meta1: item.product.sku,
                            meta2: item.product.name,
                            meta3: item.product._id,
                            count: 1,
                            value: item.product.price.value,
                            dontPushToGTM: true,
                        });
                    }
                }
                Tracker.pushToDataLayer({
                    event: type === "add" ? "ee_addToCart" : "ee_removeFromCart",
                    ecommerce: (_a = {},
                        _a[type] = {
                            products: items.map(function (i) { return ({
                                id: i.product.sku,
                                name: i.product.name,
                                price: i.product.price.value.toString(),
                                quantity: i.amount || 1,
                            }); }),
                        },
                        _a),
                });
                return [2 /*return*/];
            });
        });
    };
    Tracker.checkout = function (cart, step, option) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Tracker.pushToDataLayer({
                    event: "ee_checkout",
                    ecommerce: {
                        checkout: {
                            actionField: { step: step, option: option },
                            products: cart.items.map(function (i) { return ({
                                id: i.product.sku,
                                name: i.product.name,
                                price: i.cost.toString(),
                                quantity: i.amount,
                            }); }),
                        },
                    },
                });
                return [2 /*return*/];
            });
        });
    };
    Tracker.purchase = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Tracker.pushToDataLayer({
                    event: "ee_purchase",
                    ecommerce: {
                        purchase: {
                            actionField: {
                                id: order.orderNumber,
                                revenue: order.total.toString(),
                                tax: order.totalTax.toString(),
                            },
                            products: order.orderLines.map(function (l) { return ({
                                id: l.sku,
                                name: l.name,
                                price: (l.total + l.totalTax).toString(),
                                quantity: l.amount,
                            }); }),
                        },
                    },
                });
                return [2 /*return*/];
            });
        });
    };
    Tracker.convertToTagManager = function (opts) {
        if (opts.type === types_1.StatType.PageView) {
            return {
                event: "spa_pageview",
                url: opts.meta1 || "/",
            };
        }
        return {
            event: opts.type,
            meta1: opts.meta1,
            meta2: opts.meta2,
            meta3: opts.meta3,
            meta4: opts.meta4,
            count: typeof opts.count === "number" ? opts.count : 1,
            value: typeof opts.value === "number" ? opts.value : 1,
        };
    };
    Tracker.pushToDataLayer = function (data) {
        if (Tracker.isTmTrackable()) {
            dataLayer.push(data);
        }
    };
    Tracker.isTrackable = function () {
        return Util_1.default.isBrowser();
    };
    Tracker.isTmTrackable = function () {
        return Tracker.isTrackable() && typeof dataLayer !== "undefined";
    };
    return Tracker;
}());
exports.default = Tracker;
//# sourceMappingURL=Tracker.js.map